function getMessage(res, messageDefault) {
    let msgDef = messageDefault === undefined ?  'Falha ao executar operação!' : messageDefault
    let msg = res.body.message === undefined ? msgDef : res.body.message
    return msg
}

export default { getMessage }